import RobotSvg from './RobotSvg'

export default function WelcomeBanner({ userInfo }) {
  return (
    <div className="relative backdrop-blur-xl bg-white/60 rounded-3xl shadow-xl border border-white/40 p-6 sm:p-8 mb-6 overflow-hidden">
      {/* Shimmer Effect */}
      <div className="absolute inset-0 rounded-3xl bg-gradient-to-r from-transparent via-white/30 to-transparent animate-shimmer pointer-events-none"></div>

      {/* Animated Background Particles */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-0 right-0 w-40 h-40 bg-gradient-to-br from-blue-200/30 to-blue-200/30 rounded-full blur-3xl animate-float"></div>
        <div className="absolute bottom-0 left-0 w-32 h-32 bg-gradient-to-tr from-blue-200/30 to-pink-200/30 rounded-full blur-2xl animate-float-delayed"></div>
        <div className="absolute top-1/2 left-1/2 w-24 h-24 bg-gradient-to-br from-cyan-200/20 to-blue-200/20 rounded-full blur-xl animate-pulse"></div>
      </div>

      <div className="flex items-center gap-4 sm:gap-6 relative z-10">
        {/* Futuristic Robot Character */}
        <div className="relative flex-shrink-0 group">
          <RobotSvg />

          {/* Tech glow effect on hover */}
          <div className="absolute inset-0 bg-gradient-to-br from-cyan-400/0 via-gray-400/0 to-slate-400/0 group-hover:from-cyan-400/20 group-hover:via-gray-400/10 group-hover:to-slate-400/20 rounded-full blur-2xl transition-all duration-700 -z-10"></div>

          {/* Orbiting tech particles around robot */}
          <div className="absolute inset-0 -z-10">
            <div className="absolute top-4 left-4 w-2 h-2 bg-cyan-400 rounded-full animate-ping anim-duration-2s"></div>
            <div className="absolute top-8 right-6 w-1.5 h-1.5 bg-emerald-400 rounded-full animate-ping anim-duration-3s anim-delay-500"></div>
            <div className="absolute bottom-8 left-6 w-2 h-2 bg-gray-400 rounded-full animate-ping anim-duration-2500 anim-delay-1s"></div>
            <div className="absolute bottom-4 right-4 w-1.5 h-1.5 bg-slate-400 rounded-full animate-ping anim-duration-3500 anim-delay-300"></div>
          </div>
        </div>

        <div className="flex-1">
          <h1 className="text-2xl sm:text-3xl font-bold mb-2 flex items-center gap-2">
            <span className="bg-gradient-to-r from-gray-800 via-blue-900 to-gray-800 bg-clip-text text-transparent">
              Selamat Datang, {userInfo?.degree_prefix && `${userInfo.degree_prefix} `}{userInfo?.full_name}{userInfo?.degree_suffix && `, ${userInfo.degree_suffix}`}
            </span>
            {/* <span className="inline-block animate-wave text-2xl sm:text-3xl">👋</span> */}
          </h1>
          <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-2 text-gray-600 text-sm sm:text-base">
            {/* <span className="inline-flex items-center gap-1">
              {userInfo?.role === 'admin' ? (
                <>
                  <span className="w-2 h-2 bg-blue-500 rounded-full animate-pulse"></span>
                  <span className="font-semibold text-blue-700">Admin Dashboard</span>
                </>
              ) : (
                <>
                  <span className="w-2 h-2 bg-blue-500 rounded-full animate-pulse"></span>
                  <span className="font-semibold text-blue-700">User Dashboard</span>
                </>
              )}
            </span> */}
            <span className="text-gray-400 hidden sm:inline">•</span>
            <span className="text-xs sm:text-sm">
              <span className="sm:hidden">
                {new Date().toLocaleDateString('id-ID', { day: 'numeric', month: 'short', year: 'numeric' })}
              </span>
              <span className="hidden sm:inline">
                {new Date().toLocaleDateString('id-ID', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
              </span>
            </span>
          </div>
        </div>

        {/* Welcome Image */}
        <div className="hidden md:block relative flex-shrink-0">
          <div className="relative w-48 h-48 lg:w-56 lg:h-56">
            <div className="absolute inset-0 bg-gradient-to-br from-blue-200/40 via-blue-200/40 to-blue-200/40 rounded-full blur-3xl animate-pulse anim-duration-4s"></div>
            <div className="absolute inset-0 bg-gradient-to-tl from-blue-200/20 via-pink-200/20 to-blue-200/20 rounded-full blur-2xl animate-float-delayed"></div>

            <div className="relative w-full h-full flex items-center justify-center">
              <div className="relative group">
                <img
                  src="/assets/images/welcome-graphic-2.png"
                  alt="Welcome"
                  className="w-full h-full object-contain drop-shadow-2xl transition-all duration-500 group-hover:scale-105 group-hover:rotate-2 welcome-image"
                />
                <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-2xl"></div>
              </div>
            </div>

            <div className="absolute top-4 right-4 w-2 h-2 bg-yellow-400 rounded-full animate-ping anim-duration-2s"></div>
            <div className="absolute top-8 right-2 w-1.5 h-1.5 bg-blue-400 rounded-full animate-ping anim-duration-2500 anim-delay-300"></div>
            <div className="absolute bottom-6 left-4 w-2 h-2 bg-blue-400 rounded-full animate-ping anim-duration-3s anim-delay-700"></div>
            <div className="absolute bottom-12 left-2 w-1.5 h-1.5 bg-pink-400 rounded-full animate-ping anim-duration-3500 anim-delay-1200"></div>
          </div>
        </div>
      </div>
    </div>
  )
}
